import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "../components/Mahal/Header";
import Topbar from "../components/Mahal/Topbar";
import Footer from "../components/Footer";
import ScrollToTopProgress from "../components/ScrollToTopProgress";
import axios from "axios";

import { formatPrice } from "../utils/currency";

const API = "https://api.mahal.qa";

const OfferProductsPage = () => {

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState(["All"]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [vendors, setVendors] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [search, setSearch] = useState("");
  const [verifiedOnly, setVerifiedOnly] = useState(false);
  const [sameDayOnly, setSameDayOnly] = useState(false);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(1000);
  const [priceLimit, setPriceLimit] = useState(1000);
  const [loading, setLoading] = useState(false);

  const [totalCount, setTotalCount] = useState(0);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");

  const promotionId = queryParams.get("promotion");

  const bannerId = queryParams.get("banner");
  const keyword = queryParams.get("keyword");

  const endpoint =
    promotionId
      ? `/api/v1/promotions/${promotionId}/products`
      : (
          bannerId || keyword
            ? "/api/banner-offer-products"
            : (
                type === "today"
                  ? "/api/today-offers-products"
                  : "/api/offer-products"
              ) 
            );

  const storesEndpoint = 
    bannerId || keyword
      ? "/api/banner-offer-stores"
      : (
          type === "today"
            ? "/api/today-offer-stores"
            : "/api/offer-stores"
        );

  // useEffect(() => {
  //   // axios.get(`${API}${storesEndpoint}`)

  //   axios.get(`${API}${storesEndpoint}`, {
  //     params: {
  //       banner_id: bannerId, 
  //       keyword
  //     }
  //   })
  //     .then((res) => {
  //       // setStores(res.data.stores || []);
  //       const fetchedStores =
  //         (res.data.stores || []).filter(
  //           (s) => Number(s.total_products || 0) > 0 );
  //       setStores(fetchedStores);
  //     })
  //     .catch(console.error);
  // }, []);

  useEffect(() => {

    const restaurantId =
      localStorage.getItem("linked_id");

    axios.get(`${API}/api/restaurant-offer-stores`, {
      params:{
        restaurant_id: restaurantId,
        promotion_id: promotionId,
        banner_id: bannerId,
        keyword:keyword,
        type:type
      }
    })

      .then((res) => {
        setStores(
          res.data.stores || []
        );
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    fetchOfferProducts();
  }, [selectedStore]);

  const fetchOfferProducts = async () => {
    try {

      let sourceProducts = [];
      setLoading(true);

      const city = localStorage.getItem("restaurant_city");
      const latitude = localStorage.getItem("restaurant_latitude");
      const longitude = localStorage.getItem("restaurant_longitude");
      const restaurantId = localStorage.getItem("linked_id");

      const res = await axios.get(
        `${API}${endpoint}`,
        {
          params: promotionId
            ? {
                restaurant_id: restaurantId,
                selected_store_id: selectedStore || undefined
              }
            : {
                city,
                latitude,
                longitude,
                keyword,
                banner_id: bannerId,
                store_id: selectedStore
                  ? String(selectedStore).trim() : undefined
              }
        }
      );

      setTotalCount(
        res.data.total_count || 0
      );

      if (promotionId) {

        // const promoProducts = (res.data || []).map((p) => ({
        const promoProducts = (res.data.products || []).map((p) => ({
          product_id: p.id,
          product_name_english: p.name_en || p.name,
          category_name: p.category_name,
          supplier_name: p.supplier_name,
          supplier_id: p.supplier_id,

          image: p.img1,

          original_price: p.original_price,
          discount_price: p.discounted_price,

          currency: p.currency || "QAR",

          has_offer: true,

          offer_label:
            p.offer_label ||
            `${p.offer_value || ""} ${p.offer_type || ""}`
        }));

        sourceProducts = promoProducts

        setProducts(promoProducts);
        // setTotalCount(promoProducts.length);

        setTotalCount(
          res.data.total_count ||
          promoProducts.length
        );

        // const uniqueStores = [
        //   ...new Map(
        //     promoProducts.map(p => [
        //       p.supplier_id,
        //       {
        //         store_id: p.supplier_id,
        //         store_name_english: p.supplier_name,
        //         total_products: 1
        //       }
        //     ])
        //   ).values()
        // ];

        // setStores(uniqueStores);

      } else {

        const data = res.data.products || [];

        const validProducts = data.filter(
          (p) =>
            p.has_offer === true &&
            Number(p.discount_price || 0) > 0
        );

        sourceProducts = validProducts;

        setProducts(validProducts);
        setTotalCount(res.data.total_count || 0);
      }

      // const data = res.data.products || [];

      // const validProducts = data.filter(
      //   (p) =>
      //     p.has_offer === true &&
      //     Number(p.discount_price || 0) > 0
      // );

      // setProducts(validProducts);

      const cats = [ "All",
        ...new Set(
        // validProducts
        sourceProducts
          .map((p) => p.category_name)
          .filter(Boolean)
        )
      ];

      setCategories(cats);

      const vendorMap = {};
      // validProducts.forEach((p) => {
      sourceProducts.forEach((p) => {
        if (!p.supplier_id) return;

        if (!vendorMap[p.supplier_id]) {
          vendorMap[p.supplier_id] = {
            supplier_id: p.supplier_id,
            company_name_english: p.supplier_name || "Vendor",
            total_products: 0
          };
        }

        vendorMap[ p.supplier_id ].total_products += 1;
      });

      setVendors(Object.values(vendorMap));

      // const prices = validProducts.map( (p) =>
      const prices = sourceProducts.map( (p) =>
        Number(p.discount_price || p.original_price || 0)
      );

      // const min = prices.length ? Math.min(...prices) : 0;
      const min = prices.length ? Math.floor(Math.min(...prices)) : 0;
      // const max = prices.length ? Math.max(...prices) : 0;
      const max = prices.length ? Math.ceil(Math.max(...prices)) : 0;

      setMinPrice(min);
      setMaxPrice(max);
      setPriceLimit(max);
    } catch (err) {
      console.error("Offer Products Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredProducts = products.filter((p) => {

    const categoryMatch =
      selectedCategory === "All" ||
      p.category_name === selectedCategory;

    const price = Number(
        p.discount_price || p.original_price || 0 );

    const priceMatch = price <= priceLimit;

    const searchMatch = (p.product_name_english || "")
      .toLowerCase()
      .includes(search.toLowerCase());
      
    const verifiedMatch = !verifiedOnly || p.verified === true;

    const sameDayMatch = !sameDayOnly || p.same_day === true;

    const vendorMatch = selectedVendors.length === 0 ||
      selectedVendors.includes(p.supplier_id);

    return (
      categoryMatch &&
      priceMatch &&
      searchMatch &&
      verifiedMatch &&
      sameDayMatch &&
      vendorMatch
    );
  });

  return (
    <>
      <div className="sticky_topbar"> <Topbar /> </div>
      <div className="sticky_header"> <Header /> </div>

      <style>
        {`

          .col-xl-2{
            padding-left:12px !important;
            padding-right:12px !important;
          }

          .product_card{
            background:#fff;
            border-radius:14px;
            overflow:hidden;
            transition:0.3s ease;
            height:100%;
            position:relative;
            border:1px solid #efefef;
            box-shadow:0 2px 10px rgba(0,0,0,0.04);
          }

          .product_card:hover{
            transform:translateY(-5px);
            box-shadow:0 8px 25px rgba(0,0,0,0.08);
          }

          .product_img{
            position:relative;
            width:100%;
            height:160px;
            overflow:hidden;
            background:#fff;
            display:flex;
            align-items:center;
            justify-content:center;
          }

          .product_image_main{
            width:100%;
            height:100%;
            object-fit:contain;
            padding:10px;
          }

          .product_text{
            text-align:center;
          }

          .product_text h5{
            font-size:18px;
            font-weight:650;
            line-height:22px;
            min-height:45px;
            margin-bottom:5px;
          }

          .product_text p{
            margin-bottom:6px;
            color:#666;
          }
f
          .product_price_new{
            font-size:20px;
            font-weight:700;
            color:#1a8f3c;
          }

          .old_price{
            color:#999;
            text-decoration:line-through;
            margin-right:8px;
            font-size:16px;
          }

          .offer_badge{
            position:absolute;
            top:10px;
            left:10px;
            background:linear-gradient(135deg,#ff8c00,#ff3d00);
            color:#fff;
            padding:6px 10px;
            border-radius:8px;
            font-size:13px;
            font-weight:700;
            z-index:5;
          }

          .country_badge{
            position:absolute;
            bottom:10px;
            right:10px;
            background:#ff9800;
            color:#fff;
            padding:4px 10px;
            border-radius:20px;
            font-size:12px;
            font-weight:600;
          }

          .delivery_btn_row{
            display:flex;
            align-items:center;
            justify-content:space-between;
            gap:10px;
            margin-top:14px;
          }

          .delivery_strip{
            display:flex;
            align-items:center;
            gap:6px;
            font-size:13px;
            font-weight:700;
            color:#222;
            margin:0;
          }

          .view_btn{
            min-width:auto;
            padding:8px 16px;
            font-size:13px;
          }
          .view_btn:hover{
            background:#111;
            color:#fff;
          }

          .sticky_topbar{
            position: sticky;
            top: 0;
            z-index: 9999;
          }

          .sticky_header{
            position: sticky;
            top: 48px;
            z-index: 9998;
            background:#fff;
          }

          .unit_text{
            font-size:14px;
            color:#777;
            font-weight:500;
          }
        `}
      </style>

      <section className="shop_page mt-5 pb-80 pb_80">
        <div className="container-fluid pl-20 pr-20">

          <div className="row">

              <div className="col-lg-2 sidebar_col">
                <div className="shop_sidebar filter_card">

                  <div className="shop_sidebar_item mb_30">

                    <small> Select Store Address </small>

                    <select
                      className="filter_input"
                      value={selectedStore}
                      onChange={(e) =>
                        setSelectedStore(e.target.value)}
                    >
                      <option value=""> Select store </option>

                      {stores.map((s) => (
                        <option
                          key={s.store_id}
                          value={s.store_id}
                        >
                          {s.store_name_english}{" • "}{s.city}{" • "}{s.total_products || 0}{" Products"} 
                        </option>
                      ))}
                    </select>

                    <p
                      style={{
                        marginTop: "10px",
                        fontWeight: "600",
                        color: "#28a745"
                      }}
                    >
                      Total Fetched Products : {totalCount}
                    </p>

                    <p>
                      Stores : {stores.length}
                    </p>

                    <p>
                      Products : {totalCount}
                    </p>

                  </div>

                  <div className="shop_sidebar_item mb_30">

                    <input
                      type="text"
                      placeholder="Search product..."
                      value={search}
                      onChange={(e) => 
                        setSearch(e.target.value)}
                      className="filter_input"
                    />
                  </div>

                  <div className="shop_sidebar_item mb_30">

                    <h5> Categories </h5>
                    {categories.map((cat) => (

                      <label key={cat} className="filter_option">

                        <input
                          type="radio"
                          checked={
                            selectedCategory === cat }
                          onChange={() =>
                            setSelectedCategory(cat) }
                        />

                        <span>{cat}</span>

                      </label>
                    ))}

                  </div>

                  <div className="shop_sidebar_item mb_30">

                    <h5>Price Range</h5>

                    <input
                      type="range"
                      min={minPrice}
                      max={maxPrice}
                      value={priceLimit}
                      onChange={(e) => 
                        setPriceLimit(Number(e.target.value))}
                      className="w-100"
                    />

                    {/* <p className="mt-2">
                      { formatPrice(
                        minPrice, products?.[0]?.currency || "QAR", 0) }
                      {" — "}
                      { formatPrice(
                        priceLimit, products?.[0]?.currency || "QAR", 0) }
                    </p> */}

                    <p className="mt-2">
                      {Math.floor(minPrice)}
                      {" — "}
                      {Math.ceil(priceLimit)}
                    </p>

                  </div>

                  <div className="shop_sidebar_item mb_30">

                    <h5>Filter By Vendor</h5>

                    {vendors.map((v) => (
                      <label key={v.supplier_id} className="filter_option">

                        <input
                          type="checkbox"
                          checked={
                            selectedVendors.includes(
                            v.supplier_id) }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedVendors([
                                ...selectedVendors,
                                v.supplier_id]);
                            } else {
                              setSelectedVendors(
                                selectedVendors.filter(
                                  (id) => id !==
                                    v.supplier_id ));
                            }}}
                        />

                        <span>{v.company_name_english}{" • "}
                          {v.total_products}{" Products"}</span>

                      </label>
                    ))}

                  </div>

                  <div className="shop_sidebar_item mb_30">

                    <h5> Delivery & Trust </h5>

                    <label className="filter_option">

                      <input
                        type="checkbox"
                        checked={sameDayOnly}
                        onChange={() =>
                        setSameDayOnly(!sameDayOnly) }
                      />

                      <span> Same Day Delivery </span>
                    </label>

                    <label className="filter_option">

                      <input
                        type="checkbox"
                        checked={verifiedOnly}
                        onChange={() =>
                        setVerifiedOnly(!verifiedOnly) }
                      />

                      <span> Verified Suppliers </span>
                    </label>

                  </div>

                </div>
              </div>

            <div className="col-lg-10">
            {/* <div className={promotionId ? "col-lg-12" : "col-lg-10"}> */}
              <div className="row g-4">

                {loading && (
                  <div className="col-12 text-center">
                    <h4> Loading... </h4>
                  </div>
                )}

                {!loading && filteredProducts.length === 0 && (
                  <div className="col-12 text-center">
                    <h4> No products found </h4>
                  </div>
                )}

                {filteredProducts.map((item, i) => (
                  <div
                    className="col-xl-2 col-lg-3 col-md-4 col-sm-6"
                    key={item.product_id} >
                                      
                    <div className="product_card">

                      <div className="product_img">

                        <img
                          src={item.image}
                          alt={item.product_name_english}
                          className="product_image_main"
                        />

                        <div className="offer_badge">
                          {item.offer_label}
                        </div>

                        <div className="country_badge">
                          {item.country_of_origin || "QATAR"}
                        </div>

                      </div>

                      <div className="product_text">

                        <h5>
                          {item.product_name_english}

                          {item.unit_of_measure && (
                            <span className="unit_text">
                              {" "}({item.unit_of_measure})
                            </span>
                          )}
                        </h5>

                        <div>

                          <span className="old_price">
                            {formatPrice(item.original_price, item.currency)}
                          </span>

                          <span className="product_price_new">
                            {formatPrice(item.discount_price, item.currency)}
                          </span>

                        </div>

                        <div className="delivery_btn_row">

                          <div className="delivery_strip">
                            <i className="fas fa-shipping-fast"></i>
                            <span>30 MIN</span>
                          </div>

                          <Link
                            to={`/shopdetails/${item.product_id}${location.search}`}
                            state={{
                              offerData: {
                                has_offer: item.has_offer,
                                offer_type: item.offer_type,
                                offer_label: item.offer_label,
                                discount_price: item.discount_price,
                                original_price: item.original_price,
                                saved_amount: item.saved_amount,
                              }
                            }}
                            className="view_btn"
                          >
                            View Product
                          </Link>

                        </div>

                      </div>

                    </div>

                  </div>
                ))}

              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer/>
      <ScrollToTopProgress/>
    </>
  );
};

export default OfferProductsPage;